export const labels = {
  es: {
    employmentStatus: "Situación laboral",
    previousOccupation: "Ocupación anterior",
    occupation: "Ocupación actual",
    yearsWorked: "Años trabajados",
    yearsPreviouslyWorked: "Años trabajados",
    companyType: "Tipo de compañía (rubro)",
    companyName: "Nombre del empleador",
    companyCountry: "País del empleador",
    companyAddresses: {
      fullAddress: "Dirección del empleador",
      zipCode: "Código postal",
      city: "Ciudad",
      state: "Estado / Provincia",
      floor: "Piso",
      apartment: "Departamento",
    },
    fromPrefix: "Desde",
    toConnector: "hasta",

    // NOTE: Not nesting these as validations don't work unless they're siblings
    annualIncomeLabel: "Ingresos anuales (USD)",
    annualIncomeLowerBound: "Desde",
    annualIncomeUpperBound: "Hasta",
    netIncomeLabel: "Patrimonio neto estimado (excluir vivienda) (USD)",
    netIncomeLowerBound: "Desde",
    netIncomeUpperBound: "Hasta",
    netWorthLabel: "Patrimonio líquido estimado (USD)",
    netWorthLowerBound: "Desde",
    netWorthUpperBound: "Hasta",
  },

  en: {
    employmentStatus: "Employment Status",
    previousOccupation: "Previous Occupation",
    occupation: "Current Occupation",
    yearsWorked: "Years Worked",
    yearsPreviouslyWorked: "Years Worked",
    companyType: "Type of company (industry)",
    companyName: "Employer Name",
    companyCountry: "Employer Country",
    companyAddresses: {
      fullAddress: "Employer Address",
      zipCode: "Postal Code",
      city: "City",
      state: "State / Province",
      floor: "Floor",
      apartment: "Department",
    },
    fromPrefix: "From",
    toConnector: "to",

    // NOTE: Not nesting these as validations don't work unless they're siblings
    annualIncomeLabel: "Annual Income (USD)",
    annualIncomeLowerBound: "From",
    annualIncomeUpperBound: "To",
    netIncomeLabel: "Estimated Net Worth (exclude home) (USD)",
    netIncomeLowerBound: "From",
    netIncomeUpperBound: "To",
    netWorthLabel: "Estimated Liquid Assets (USD)",
    netWorthLowerBound: "From",
    netWorthUpperBound: "To",
  },
};

export const title = {
  es: "Información laboral y financiera",
  en: "Employment and Financial Information",
};

export const texts = {
  es: {
    section1: "Sección 1: Situación laboral y ocupación",
    section2: "Sección 2: Información del empleador",
    "section2-financeInfo": "Sección 2: Información financiera",
    section3: "Sección 3: Información financiera",
    personalAssetsSubtitle:
      "Esta información corresponde a tu patrimonio personal, no al de tu empleador.",
    lowerBoundTooLargeMessage: "Debe ser menor al monto máximo.",
    upperBoundTooSmallMessage: "Debe ser mayor al monto mínimo.",
    netIncomeTooSmallMessage: "Debe ser mayor al monto máximo del ingreso anual.",
    netIncomeLowerBoundTooSmallMessage: "Debe ser mayor al monto mínimo del ingreso anual.",
    netWorthTooLargeMessage: "Debe ser menor al monto máximo del patrimonio neto.",
    netWorthLowerBoundTooLargeMessage: "Debe ser menor al monto mínimo del patrimonio neto.",
  },

  en: {
    section1: "Section 1: Employment Status and Occupation",
    section2: "Section 2: Employer Information",
    "section2-financeInfo": "Section 2: Financial Information",
    section3: "Section 3: Financial Information",
    personalAssetsSubtitle:
      "This information pertains to your personal assets, not those of your employer.",
    lowerBoundTooLargeMessage: "Has to be less than the maximum amount.",
    upperBoundTooSmallMessage: "Has to be greater than the minimum amount.",
    netIncomeTooSmallMessage: "Has to be greater than the maximum amount of the annual income.",
    netIncomeLowerBoundTooSmallMessage: "Has to be greater than the minimum amount of the annual income.",
    netWorthTooLargeMessage: "Has to be less than the maximum amount of the net worth.",
    netWorthLowerBoundTooLargeMessage: "Has to be less than the minimum amount of the net worth.",
  },
};

export const placeholders = {
  es: {
    employmentStatus: "Seleccioná una opción",
    previousOccupation: "Ej. Contador",
    occupation: "Ej. Contador",
    yearsWorked: "Ej. 15",
    yearsPreviouslyWorked: "Ej. 15",
    companyType: "Ej. Finanzas",
    companyName: "Pyme SA",
    companyCountry: "Seleccioná una opción",
    companyAddresses: {
      fullAddress: "Calle y número",
      zipCode: "Ej. 1426",
      city: "ej. CABA",
      state: "Ej. Buenos Aires",
      floor: "Ej. 1",
      apartment: "Ej. A",
    },
    annualIncome: "$",
    netIncome: "$",
    netWorth: "$",
  },

  en: {
    employmentStatus: "Select an option",
    previousOccupation: "e.g. Employee",
    occupation: "e.g. Accountant",
    yearsWorked: "e.g. 15",
    yearsPreviouslyWorked: "e.g. 15",
    companyType: "e.g. Finance",
    companyName: "SME Inc.",
    companyCountry: "Select an option",
    companyAddresses: {
      fullAddress: "Street and Number",
      zipCode: "e.g. 1426",
      city: "e.g. CABA",
      state: "e.g. Buenos Aires",
      floor: "e.g. 1",
      apartment: "e.g. A",
    },
    annualIncome: "$",
    netIncome: "$",
    netWorth: "$",
  },
};

export const tooltips = {
  es: {
    occupation:
      "Ingresá una ocupación específica (ej. \"contador\", \"ingeniero civil\", \"médico\") en lugar de términos generales como \"asesor\" o \"profesional\"",
  },

  en: {
    occupation:
      "Enter a specific occupation (e.g. \"accountant\", \"civil engineer\", \"physician\") rather than more general terms such as \"advisor\" or \"professional\"",
  },
};